import { render, staticRenderFns } from "./Consumption2.vue?vue&type=template&id=5fe30c07&scoped=true"
import script from "./Consumption2.vue?vue&type=script&lang=js"
export * from "./Consumption2.vue?vue&type=script&lang=js"
import style0 from "./Consumption2.vue?vue&type=style&index=0&id=5fe30c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe30c07",
  null
  
)

export default component.exports